/**
 * @author vishwadeep.kapoor
 * @Date: 2020-10-06 17:03:58
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2021-01-05 17:01:29
 */
import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Box, Flex } from 'grid-styled';
import { Button } from 'antd';
import { Input, Loader } from '../../../components';
import { AppWrappperHOC } from '../../Root/HOC';
import ProfileNavigation from '../ProfileNavigation';
import { StyledProfile } from '../index';
import Container from '../../../components/Container';
import { constants, utils } from '../../../devUtils';
import { CreateAccountProps, CreateAccountMapDispatchToProps, CreateAccountMapStateToProps } from '../profileDataHandler';

class CreateAccount extends PureComponent {
  constructor() {
    super();
    this.state = { isShowAadhaarKyc: false, aadhaar: '', otp: '', aadhaarOtp: '' };
    this.renderScreenUI = this.renderScreenUI.bind(this);
  }

  componentWillMount() {
    const { onWalletRegister, UserDetails: { phone, ybl_kyc_done } } = this.props;
    if (!ybl_kyc_done) {
      onWalletRegister({ mobile: phone });
    }
  }

  renderScreenUI() {
    const {
      onAadharRegister,
      onWalletRegister,
      onPhysicalCardActivate,
      history,
      UserDetails: { phone, ybl_kyc_done, ybl_physical_card, ybl_virtual_card, ybl_activation_by, ybl_physical_card_linked },
      WalletRegisterSubmit: { message, otp_ref_number, token } = {},
      AadharRegisterSubmit: { otp_trans_id, message: _message, transaction_id },
    } = this.props;
    const { isShowAadhaarKyc, otp, aadhaar, aadhaarOtp } = this.state;
    if (ybl_kyc_done && ybl_activation_by === 'user') {
      return (
        <Fragment>
          <span className="gray-text">Aadhaar eKYC Completed Successfully.<br /> Please {!ybl_physical_card_linked && ybl_physical_card ? 'Activate' : 'view'} your </span>
          {!ybl_physical_card_linked && ybl_physical_card ? 'Physical Card' : null}
          {(ybl_physical_card && ybl_physical_card_linked) ?
            <strong
              role="presentation"
              className="red-text"
              style={{ cursor: 'pointer' }}
              onClick={() => utils.forceRedirect(history, { pathname: `${constants.LINK_ZAGGLE_CARD_DEAILS}/physical` })}
            > Physical Card
            </strong> : null}
          {ybl_virtual_card ?
            <strong
              role="presentation"
              className="red-text"
              style={{ cursor: 'pointer' }}
              onClick={() => utils.forceRedirect(history, { pathname: `${constants.LINK_ZAGGLE_CARD_DEAILS}/virtual` })}
            >
              Virtual Card
            </strong> : null}
          {!ybl_physical_card_linked && !ybl_virtual_card ?
            <div className="margin-t-1">
              <Button type="primary" onClick={() => utils.forceRedirect(history, { pathname: constants.LINK_ACCOUNT_ACTIVATE })}>Activate Physical Card</Button>
            </div> : null}
        </Fragment>);
    } else if (ybl_kyc_done && ybl_activation_by === 'zaggle') {
      if (!ybl_physical_card_linked) {
        return (
          <Fragment>
            <span className="gray-text">Aadhaar eKYC Completed Successfully.<br /> Please view your </span>
            <strong
              role="presentation"
              className="red-text"
              style={{ cursor: 'pointer' }}
              onClick={() => onPhysicalCardActivate({}, { apiMethod: 'GET' })}
            > Physical Card
            </strong>
          </Fragment>);
      }
      return utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
    } else if (otp_ref_number) {
      return (
        <Fragment>
          <span className="gray-text">{message}</span><br /><br />
          <Input
            placeholder="Enter OTP"
            key="otp"
            style={{ width: '46%' }}
            onChange={({ target }) => this.setState({ otp: target.value })}
          /><br /><br />
          <Button type="link" onClick={() => onWalletRegister({ mobile: phone })}>Resend OTP</Button>
          <Button type="primary" style={{ marginLeft: '20%' }} onClick={() => onWalletRegister({ mobile: phone, otp, otp_ref_number })}>Submit</Button>
        </Fragment>
      );
    } else if (otp_trans_id) {
      return (
        <Fragment>
          <span className="gray-text">{_message}</span><br /><br />
          <Input
            placeholder="Enter OTP"
            key="aadhar_otp"
            style={{ width: '46%' }}
            onChange={({ target }) => this.setState({ aadhaarOtp: target.value })}
          /><br /><br />
          <Button type="link" onClick={() => onWalletRegister({ mobile: phone })}>Start Over</Button>
          <Button type="primary" style={{ marginLeft: '20%' }} onClick={() => onAadharRegister({ mobile: phone, aadhaar, transaction_id, otp_trans_id, otp: aadhaarOtp })}>Submit</Button>
        </Fragment>
      );
    } else if (token && !isShowAadhaarKyc) {
      return (
        <Fragment>
          <span className="gray-text">Your Card Account is created.</span>
        </Fragment>
      );
    } else if (token && isShowAadhaarKyc) {
      return (
        <Fragment>
          <span className="gray-text">{message}</span><br /><br />
          <Input
            placeholder="Aadhaar number"
            key="adhaar_number"
            style={{ width: '40%' }}
            onChange={({ target }) => this.setState({ aadhaar: target.value })}
          /><br /><br />
          <Button type="primary" onClick={() => onAadharRegister({ mobile: phone, token, aadhaar })}>Submit</Button>
        </Fragment>);
    }
    return (<span className="gray-text">Error</span>);
  }

  render() {
    const {
      history,
      isLoading,
      UserDetails: { isOnlyMerchandise },
    } = this.props;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <StyledProfile>
        <Container>
          <br clear="all" />
          <Flex flexWrap="wrap" className="margin-t-3">
            <Box width={[12 / 12, 5 / 24]} pl={10}>
              <ProfileNavigation isOnlyMerchandise={isOnlyMerchandise} history={history} />
            </Box>
            <Box width={[12 / 12, 19 / 24]} pr={10}>
              <div className="Card_account_creation">
                <Flex flexWrap="wrap">
                  <Box width={[12 / 12, 12 / 12]}>
                    <h1 className="font-20 nomargin-left">Yes Bank Account Registration</h1>
                    {this.renderScreenUI()}
                  </Box>
                </Flex>
              </div>
            </Box>
          </Flex>
        </Container>
      </StyledProfile>);
  }
}

CreateAccount.propTypes = CreateAccountProps;

const component = connect(CreateAccountMapStateToProps, CreateAccountMapDispatchToProps)(AppWrappperHOC(CreateAccount));
export { CreateAccount };

export default component;



// WEBPACK FOOTER //
// client/containers/Profile/CreateAccount/index.jsx